<template>
  <div ref="root" class="call topPage">
    <div class="slider-outer">
      <div class="slider-inner sp-none">
        <template :key="idx" v-for="(slide, idx) in state.slides">
          <img :class="state.current_slide == idx ? 'active' : ''" class="slide-img"
            v-bind:src="state.slides[idx].img" />
          <div class="slider-text slider-text1" v-if="state.current_slide === 0"><span class="text-gold">美</span>しく
          </div>
          <div class="slider-text slider-text2" v-else-if="state.current_slide === 1"><span class="text-pink">楽</span>しく
          </div>
          <div class="slider-text slider-text3" v-else-if="state.current_slide === 2"><span
              class="text-gold">華</span>やかに</div>
          <div class="slider-text slider-text4" v-else-if="state.current_slide === 3">キック<span
              class="text-pink">ボ</span>クシングフィットネス</div>
        </template>
      </div>
      <div class="slider-inner pc-none">
        <template :key="idx" v-for="(slide, idx) in state.slides2">
          <img :class="state.current_slide == idx ? 'active' : ''" class="slide-img"
            v-bind:src="state.slides2[idx].img" />
          <div class="slider-text slider-text1" v-if="state.current_slide === 0"><span class="text-gold">美</span>しく
          </div>
          <div class="slider-text slider-text2" v-else-if="state.current_slide === 1"><span class="text-pink">楽</span>しく
          </div>
          <div class="slider-text slider-text3" v-else-if="state.current_slide === 2"><span
              class="text-gold">華</span>やかに</div>
          <div class="slider-text slider-text4" v-else-if="state.current_slide === 3">キック<span
              class="text-pink">ボ</span>クシング<br />フィットネス</div>
        </template>
      </div>
    </div>

    <div class="top-content">
      <!-- Head-->
      <section class="top-content-head top-content-primary">
        <div id="concept" class="concept">
          <div class="top-items-title fade-in">
            <h2>Concept</h2>
            <p>キックボクシングをやって元気に</p>
          </div>

          <div class="fade-in top-content-des">
            <p>痩せたい...</p>
            <p>運動不足を解消したい...</p>
            <p>試合に出てみたい...</p>
            <p>強くなりたい...</p>
            <p>etc...</p>
          </div>

          <div class="fade-in top-content-des">
            <p>CYCLONE GYMでは会員様の理想とする身体に仕上げられるようお手伝いさせて頂きます。</p>
          </div>

          <div class="concept-bg">
            Make The Body<br />
            You Dream About
          </div>
        </div>

        <div id="news" class="news fade-in">
          <div class="top-items-title">
            <h2>News</h2>
            <p>お知らせ</p>
          </div>
          <ul class="news-list">
            <template v-for="(obj, index) in state.news" :key="index">
              <li class="news-list-item">
                <router-link @click="setCurrentPage" :to="{
                  name: 'News',
                  query: { id: obj.id },
                }">
                  <div class="news-list-date">
                    {{ obj.date }}
                  </div>
                  <div class="news-list-title">
                    {{ obj.title }}
                  </div>
                </router-link>
              </li>
            </template>
          </ul>

          <div class="news-button-wrap">
            <div :class="['news-button', { none: isButtonActive('prev') }]" @click="prevButton">
              前へ
            </div>

            {{ state.currenPage }} / {{ Math.ceil(state.news2.length / 5) }}

            <div :class="['news-button', { none: isButtonActive('next') }]" @click="nextButton">
              次へ
            </div>
          </div>

        </div>
      </section>

      <section class="">
        <div id="lesson" class="lesson fade-in">
          <div class="top-items-title">
            <h2>Lesson</h2>
            <p>スケジュール</p>
            <div class="lesson-schedule-note">
              <div class="checkbox-list-text">こちらからスケジュール表を切り替えられます</div>
              <ul class="checkbox-list">
                <li :class="['checkbox__item', { on: isCheckedProduct2('月曜日') }]" @click="selectWeek('月曜日')">月曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('火曜日') }]" @click="selectWeek('火曜日')">火曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('水曜日') }]" @click="selectWeek('水曜日')">水曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('木曜日') }]" @click="selectWeek('木曜日')">木曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('金曜日') }]" @click="selectWeek('金曜日')">金曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('土曜日') }]" @click="selectWeek('土曜日')">土曜日</li>
                <li :class="['checkbox__item', { on: isCheckedProduct2('日曜日') }]" @click="selectWeek('日曜日')">日曜日</li>
              </ul>
            </div>
          </div>
          <div class="lesson-schedulebox-wrap">
            <div class="lesson-schedulebox">
              <ul>
                <li class="hours">
                  <dl>
                    <dt></dt>
                    <dd>
                      <p>10:00</p>
                    </dd>
                    <dd>
                      <p>11:00</p>
                    </dd>
                    <dd>
                      <p>12:00</p>
                    </dd>
                    <dd>
                      <p>13:00</p>
                    </dd>
                    <dd>
                      <p>14:00</p>
                    </dd>
                    <dd>
                      <p>15:00</p>
                    </dd>
                    <dd>
                      <p>16:00</p>
                    </dd>
                    <dd>
                      <p>17:00</p>
                    </dd>
                    <dd>
                      <p>18:00</p>
                    </dd>
                    <dd>
                      <p>19:00</p>
                    </dd>
                    <dd>
                      <p>20:00</p>
                    </dd>
                    <dd>
                      <p>21:00</p>
                    </dd>
                    <dd>
                      <p>22:00</p>
                    </dd>
                  </dl>
                </li>
                <li class="monday" v-if="!state.isSP || state.week[0] === '月曜日' && state.isSP">
                  <dl>
                    <dt>月曜日</dt>
                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classYOGA">
                      <p class="class">ミットスキル<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classFit row-05">
                      <p class="class">ボディメイク<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classRegi row-05">
                      <p class="class">筋膜リリース<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="row-4">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="classRhythm">
                      <p class="class">CLUB<br>リズムキック<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="tuesday" v-if="!state.isSP || state.week[0] === '火曜日' && state.isSP">
                  <dl>
                    <dt>火曜日</dt>
                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classRegi row-05">
                      <p class="class">筋膜リリース<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classFit row-05">
                      <p class="class">ボディメイク<span class="keep">(30分)</span></p>
                    </dd>



                    <dd class="row-5">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd class="row-05">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="classEntry row-05">
                      <p class="class">エントリーキック<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="wednesday" v-if="!state.isSP || state.week[0] === '水曜日' && state.isSP">
                  <dl>
                    <dt>水曜日</dt>
                    <dd class="classLadies">
                      <p class="class">レディースキック<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classFat row-05">
                      <p class="class">ファットバーン<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classRegi row-05">
                      <p class="class">筋膜リリース<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="row-5">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="classFit row-05">
                      <p class="class">ボディメイク<br />クラス<span class="keep">(30分)</span></p>
                    </dd>

                    <dd class="classFat row-05">
                      <p class="class">ファットバーン<span class="keep">(30分)</span></p>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="thursday" v-if="!state.isSP || state.week[0] === '木曜日' && state.isSP">
                  <dl>
                    <dt>木曜日</dt>
                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classFit row-05">
                      <p class="class">ボディメイク<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classRegi row-05">
                      <p class="class">筋膜リリース<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="row-5">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="friday" v-if="!state.isSP || state.week[0] === '金曜日' && state.isSP">
                  <dl>
                    <dt>金曜日</dt>
                    <dd class="classLadiesEntry row-05">
                      <p class="class">レディースエントリー<br><span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classLadies">
                      <p class="class">レディースキック<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classBiginer2 row-05">
                      <p class="class">キック中級<span class="keep">(30分)</span></p>
                    </dd>

                    <dd class="classSPA">
                      <p class="class">マススパーリング<br>クラス<span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="row-4">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd class="row-05">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="classBiginer2 row-05">
                      <p class="class">キック中級<span class="keep">(30分)</span></p>
                    </dd>
                    <dd class="classSPA">
                      <p class="class">マススパーリング<br>クラス<span class="keep">（1時間）</span></p>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="saturday" v-if="!state.isSP || state.week[0] === '土曜日' && state.isSP">
                  <dl>
                    <dt>土曜日</dt>
                    <dd class="row-2">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>

                    <dd class="classFit row-05">
                      <p class="class">ボディメイク<span class="keep">(30分)</span></p>
                    </dd>

                    <dd class="classFat row-05">
                      <p class="class">ファットバーン<span class="keep">(30分)</span></p>
                    </dd>



                    <dd class="classBiginer">
                      <p class="class">キック初級<br><span class="keep">（1時間）</span></p>
                    </dd>
                    <dd class="classRhythm">
                      <p class="class">リズムキック<br><span class="keep">（1時間）</span></p>
                    </dd>

                    <dd class="classRegi row-05">
                      <p class="class">筋膜リリース<span class="keep">(30分)</span></p>
                    </dd>


                    <dd class="row-1-05">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-2 row-flex">
                      <div class="classStrengthen">
                        <p class="class">強化<span class="keep">クラス</span><br><span class="sm">※選手<span
                              class="keep">コース</span></span>
                        </p>
                      </div>
                      <div class="classStudent">
                        <div>
                          <p class="class">学生<span class="keep">クラス</span><br><span class="sm">※学生入門<span
                                class="keep">コース</span></span></p>
                        </div>

                      </div>
                    </dd>
                    <dd>
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-3 row-close">CLOSE</dd>
                  </dl>
                </li>
                <li class="sunday" v-if="!state.isSP || state.week[0] === '日曜日' && state.isSP">
                  <dl>
                    <dt>日曜日</dt>
                    <dd class="row-2 row-close">CLOSE</dd>
                    <dd class="row-6">
                      <p class="class">フリータイム<br>ミット対応可</p>
                    </dd>
                    <dd class="row-5 row-close">CLOSE</dd>
                  </dl>
                </li>
              </ul>
              <p class="lesson-schedule-note2">※クラス以外の時間はフリータイムとなりますので、<span class="pc-none-inline"><br></span>ミット対応可能です
              </p>
            </div>
          </div>
          <div class="annotation-wrap">
            <p class=" annotation">※レッスン開始５分後までに参加者が2名に満たなかった場合、レッスンは休講となりフリータイムとなります。</p>
          </div>

        </div>
      </section>

      <section class="top-content-head top-content-primary">
        <div id="menu" class="menu fade-in">
          <div class="top-items-title">
            <h2>Lesson</h2>
            <p>クラス紹介</p>
          </div>
          <ul class="menu-list">
            <li class="menu-list-item">
              <div class="menu-list-wrap">
                <div class="menu-list-img">
                  <img src="~@/assets/img/menu/1.jpg" />
                </div>



                <div class="menu-list-text">
                  <div class="menu-list-title">キック初級クラス</div>
                  <div class="menu-list-des">
                    キックが初めての方でも楽しめ<br />
                    更に基礎からしっかり学べます！
                  </div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">キック中級クラス</div>
                  <div class="menu-list-des">
                    対人練習をメインに簡単な攻撃・防御を行うクラス。<br>
                    金曜日20:00〜のマススパーリングクラス前に練習し、<br>
                    実戦で出来るように行なっていきます。<br>
                    常に頭を使いながら身体を動かすので、代謝アップに繋がります。<br>
                  </div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">エントリーキッククラス<br>レディースエントリーキッククラス</div>
                  <div class="menu-list-des">
                    キックボクシング入門の初心者向けクラス。<br>
                    正しいフォームからパンチ・キックを細かく説明しながら行なっていきます。<br>
                    慣れている方でも初心に帰って、見直すことも出来るのでオススメです。
                  </div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">レディースキッククラス</div>
                  <div class="menu-list-des">
                    女性限定のキックボクシングクラス。<br>
                    老若男女みんなでのトレーニングに緊張してしまう方や、<br>
                    周りの目を気にしてしまう方、ついていけるか心配…<br>
                    そんな女性の方は是非こちらのクラスへご参加ください。
                  </div>
                </div>

                <div class="menu-list-img">
                  <img src="~@/assets/img/menu/2.jpg" />
                </div>



                <div class="menu-list-text">
                  <div class="menu-list-title">リズムキッククラス</div>
                  <div class="menu-list-des">音楽をかけキックボクシングの動きを<br />使ってリズムにのって楽しく動くクラスです！</div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">CLUBリズムキッククラス</div>
                  <div class="menu-list-des">
                    暗闇空間でのムービングライトの照明演出の中、爆音の音楽の合わせてキックボクシングを行うクラス。<br>
                    リズムキッククラスとは違い、人目を気にすることなく非日常空間で高揚感を感じながら有酸素運動が行えます。
                  </div>
                </div>



                <div class="menu-list-text">
                  <div class="menu-list-title">強化クラス</div>
                  <div class="menu-list-des">17:00〜19:00は選手育成コース<br>
                    心と身体共に鍛えることを初め、<br>
                    芯を強くしていきます！試合にも出場できます！</div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">学生クラス</div>
                  <div class="menu-list-des">17:00〜18:30のキックボクシング入門コース<br>
                    ※学生会員はこちらになります。(対象：小学校1年生〜中学校3年生 ※高校生以上の方は一般会員となります)<br>
                    礼儀を中心にキックボクシングを学びダイエットや運動不足解消、フィットネスとして行なっていきます。<br>
                    <span style="font-size: 80%;">(対象：小学校1年生〜中学校3年生 ※高校生以上の方は一般会員となります)</span>
                  </div>
                </div>

                <div class="menu-list-img">
                  <img src="~@/assets/img/menu/3.jpg" />
                </div>


                <!-- <div class="menu-list-text">
                  <div class="menu-list-title">YOGAクラス</div>
                  <div class="menu-list-des">
                    第2,4月曜日・木曜日・土曜日<br>呼吸・姿勢・瞑想を組み合わせて、<br />心身の緊張をほぐし、心の安定と<br />やすらぎを得ていきます！</div>
                </div> -->

                <div class="menu-list-text">
                  <div class="menu-list-title">ミットスキルクラス</div>
                  <div class="menu-list-des">
                    会員様同士でミットを持ち合うクラスになります。<br>
                    ミット持ちのスキルを学ぶことで、キックボクシングの上達を計ることが出来ます。フリータイムの中での仲の良い会員様同士のコミニケーション向上にも繋がります。
                  </div>
                </div>



                <div class="menu-list-text">
                  <div class="menu-list-title">ボディメイククラス</div>
                  <div class="menu-list-des">下半身から上半身まで、参加者のレベルに合わせた<br />ボディメイクトレーニングが出来ます！<br /><span>※中履きが必要です</span>
                  </div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">ファットバーンクラス</div>
                  <div class="menu-list-des">タバタ式トレーニングで脂肪燃焼 有酸素運動が苦手な方も<br />しっかり動いて燃焼出来るクラスです！</div>
                </div>

                <div class="menu-list-img">
                  <img src="~@/assets/img/menu/4.jpg" />
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">マススパーリングクラス</div>
                  <div class="menu-list-des">
                    試合形式で行う、実践トレーニングとなります。<br>レガース(足にはめる防具)、大きめのグローブ(16oz)をつけて相手にダメージを与えることなく、攻撃や防御のトレーニングになります。<br>ミットよりさらに実践的になったパンチやキックをディフェンスを駆使し動くため運動量が多くなり、脂肪燃焼の効果はより高まります。
                  </div>
                </div>

                <div class="menu-list-text">
                  <div class="menu-list-title">筋膜リリースクラス</div>
                  <div class="menu-list-des">
                    フォームローラーを使って身体を解していくストレッチ中心のクラス。<br>
                    身体の柔軟性・姿勢・パフォーマンスの向上・肩こり・腰痛の改善に繋がります。<br>
                    クラス前やクラス後にオススメです。

                  </div>

                  <p class="annotation mt16 pl0">※レッスン開始５分後までに参加者が2名に満たなかった場合、<br class="sp-none">レッスンは休講となりフリータイムとなります。
                  </p>
                </div>



              </div>
            </li>
          </ul>

          <div class="menu-list-bg">
            <img src="~@/assets/img/menu/1.jpg" />
          </div>
          <div class="menu-list-bg menu-list-bg2">
            <img src="~@/assets/img/menu/2.jpg" />
          </div>
          <div class="menu-list-bg menu-list-bg3">
            <img src="~@/assets/img/menu/3.jpg" />
          </div>

          <div class="menu-list-bg menu-list-bg4">
            <img src="~@/assets/img/menu/4.jpg" />
          </div>

          <div class="menu-list-bg menu-list-bg5">
            <img src="~@/assets/img/menu/5.jpg" />
          </div>
        </div>

        <div class="price-button fade-in">
          <div class="attention">
            <p>体験、見学受付中<br />こちらから</p>
          </div>

          <div class="button-wrap">
            <div class="button">
              <router-link to="/Contact" @click="onTapReturnButton">
                <div class="icon-arrow-left"></div>
                お問い合わせ
              </router-link>
            </div>
          </div>
        </div>

        <div id="price" class="price">
          <div class="fade-in">


            <div class="top-items-title">
              <h2>Price</h2>
              <p>料金</p>
            </div>
            <div class="price-cam">
              <div class="attention-wrap">
                <div class="attention">
                  <p>キャンペーン実施中</p>
                </div>
              </div>

              <div class="price-cam-item-wrap">
                <div class="price-cam-item">
                  <div class="price-cam-item-title">新規でご検討の方</div>
                  <div class="price-cam-item-des">
                    <div class="price-cam-item-des-title">新規入会キャンペーン</div>
                    <div class="price-cam-item-des-text">

                      入会金<span class="fw">無料！</span><br />
                      初月会費<span class="fw">無料！</span><br>

                      <div class="lh1">
                        顔認証登録手数料の<br>
                        <div class="price-item-des-numtext fs26">2200</div>円が
                        <span class="fw">今だけ無料！</span>
                      </div>

                    </div>
                    <div class="price-cam-item-note">
                      <div class="price-cam-item-note-title">注意事項</div>
                      <div class="price-cam-item-note-text">
                        ・本キャンペーンのご入会の場合６ヶ月の在籍が必要となります。 <br />
                        また期間内での退会・休会理由の如何を問わず６ヶ月の在籍条件となりますので、ご注意ください。 <br />
                        ・ビジターはキャンペーン適用外です。
                      </div>
                    </div>
                  </div>
                  <div class="button-wrap">
                    <div class="button">
                      <router-link to="#price-list" @click="selectPrice('新規入会キャンペーン')">
                        キャンペーン適用時の<br />
                        料金を確認する
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="price-cam-item">
                  <div class="price-cam-item-title">スポーツジムの乗り換えを<span class="pc-none-inline"><br></span>ご検討の方</div>
                  <div class="price-cam-item-des">
                    <div class="price-cam-item-des-title">のりかえキャンペーン</div>
                    <div class="price-cam-item-des-text">

                      初月会費<span class="fw">無料！</span><br />
                      2ヶ月目の月会費<span class="fw">半額！</span><br>
                      <div class="lh1">
                        顔認証登録手数料の<br>
                        <div class="price-item-des-numtext fs26">2200</div>円が
                        <span class="fw">今だけ無料！</span>
                      </div>

                    </div>
                    <div class="price-cam-item-note">
                      <div class="price-cam-item-note-title">注意事項</div>
                      <div class="price-cam-item-note-text">
                        ・2ヶ月以内にスポーツジム(格闘技・フィットネスジム・ヨガなども含む) 又はキックボクシングを退会された方、退会予定の方に限り適用されます。<br />
                        ・前所属の会員証、又は退会届をお持ちください。
                      </div>
                    </div>
                  </div>

                  <div class="button-wrap">
                    <div class="button">
                      <router-link to="#price-list" @click="selectPrice('のりかえキャンペーン')">
                        キャンペーン適用時の<br />
                        料金を確認する
                      </router-link>
                    </div>
                  </div>
                </div>


                <div class="price-cam-item-wrap2">

                  <div class="price-cam-item">
                    <div class="price-cam-item-title">平日昼間をご検討の方</div>
                    <div class="price-cam-item-des">
                      <div class="price-cam-item-des-title">デイタイムキャンペーン</div>
                      <div class="price-cam-item-des-text">
                        男性会員 女性会員 <span class="fw">共通！</span><br />
                        <span class="text-blue">男性</span>
                        <div class="price-item-des-numtext">8500</div>円 <span class="pc-none-inline"><br></span><span
                          class="text-pink">女性</span>
                        <div class="price-item-des-numtext">8000</div>
                        円
                        <div class="arrow-bottom"></div>
                        <span class="fade-in mb20">キャンペーン中のご入会に限り！</span><br>
                        <div class="fwra"> <span class="fade-in">この先</span><span
                            class="fw fade-in fade-in-text"><span>ず</span><span>ー</span><span>ー</span><span>ー</span><span>っ</span><span>と</span></span>
                        </div>
                        <div class="price-item-des-numtext2-wrap">
                          <span class="fw fb fade-in price-item-des-numtext2">5880円！！</span>
                        </div>

                        <div class="mb40 mt40">
                          <span class="fw fade-in fade-in-text"><span>さ</span><span>ら</span><span>に</span></span>
                        </div>

                        <div class="lh1">
                          顔認証登録手数料の<br>
                          <div class="price-item-des-numtext fs26">2200</div>円が
                          <span class="fw">今だけ無料！</span>
                        </div>

                        <div class="fade-in"> 初月会費も<span class="fw">無料！</span><br />
                          入会金も<span class="fw">無料！</span></div>







                        <div class="box4 fade-in">
                          <p>

                            月〜金
                            10:00〜16:00

                          </p>
                          <div class="con1">
                            キックボクシングだけじゃなく<br>
                            筋トレエリア、筋トレクラスの<span class="fw">利用可能！！</span>
                          </div>
                          <div class="con1">
                            ジム内全て使えて、<span class="fw">充実の6時間！</span><br>
                            <span class="sm">
                              ※最終退館時刻は15:50となります。
                            </span>
                          </div>





                        </div>
                      </div>
                      <div class="price-cam-item-note">
                        <div class="price-cam-item-note-title">注意事項</div>
                        <div class="price-cam-item-note-text">
                          ・入会キャンペーンと同様、6ヶ月間の在籍が必要となります。<br />
                        </div>
                      </div>
                    </div>

                    <div class="button-wrap">
                      <div class="button">
                        <router-link to="#price-list" @click="selectPrice('デイタイムキャンペーン')">
                          キャンペーン適用時の<br />
                          料金を確認する
                        </router-link>
                      </div>
                    </div>
                  </div>

                </div>





                <div class="price-cam-item-wrap2">

                  <div class="price-cam-item">
                    <div class="price-cam-item-title">体験をご検討の方</div>
                    <div class="price-cam-item-des">
                      <div class="price-cam-item-des-title">体験料<span class="pc-none-inline"><br></span>キャッシュバック<span
                          class="pc-none-inline"><br></span>キャンペーン</div>
                      <div class="price-cam-item-des-text">
                        体験料<br />
                        <span class="fw">全額キャッシュバック！</span><br />


                        入会金<span class="fw">無料！</span><br />
                        初月会費<span class="fw">無料！</span><br>

                        <div class="lh1">
                          顔認証登録手数料の<br>
                          <div class="price-item-des-numtext fs26">2200</div>円が
                          <span class="fw">今だけ無料！</span>
                        </div>

                      </div>
                      <div class="price-cam-item-note">
                        <div class="price-cam-item-note-title">注意事項</div>
                        <div class="price-cam-item-note-text">
                          ・体験から2週間以内にご入会の場合の方に限り適用されます。<br />
                        </div>
                      </div>
                    </div>

                    <div class="button-wrap">
                      <div class="button">
                        <router-link to="/Contact" @click="onTapReturnButton">
                          体験予約する<br />
                        </router-link>
                      </div>
                    </div>
                  </div>

                </div>







              </div>
            </div>
          </div>
          <div id="price-list" class="price-list-sub fade-in">
            <div class="top-items-title">
              <h2>Price</h2>
              <p>料金表</p>
              <div>- {{ state.price[0] }} -</div>
            </div>
            <div class="checkbox-list-text">こちらから料金表を切り替えられます</div>
            <ul class="checkbox-list">
              <li :class="['checkbox__item', { on: isCheckedProduct('通常料金') }]" @click="selectPrice('通常料金')">通常料金</li>
              <li :class="['checkbox__item', { on: isCheckedProduct('新規入会キャンペーン') }]"
                @click="selectPrice('新規入会キャンペーン')">
                新規入会キャンペーン</li>
              <li :class="['checkbox__item', { on: isCheckedProduct('のりかえキャンペーン') }]"
                @click="selectPrice('のりかえキャンペーン')">
                のりかえキャンペーン</li>
              <li :class="['checkbox__item', { on: isCheckedProduct('デイタイムキャンペーン') }]"
                @click="selectPrice('デイタイムキャンペーン')">
                デイタイムキャンペーン</li>
            </ul>
          </div>
          <div class="price-list-wrap fade-in">
            <ul class="price-list">
              <li class="price-list-item">
                <div class="price-list-title">入会金</div>
                <div v-if="state.price[0] === '通常料金'" class="price-list-des">
                  <div class="price-list-des-grid2">11,000円</div>
                </div>
                <div v-else class="price-list-des">
                  <div class="price-list-des-grid2"><span class="text-pink2">0</span>円</div>
                </div>
              </li>
              <li v-if="state.price[0] != 'デイタイムキャンペーン'" class="price-list-item">
                <div class="price-list-title">一般会員</div>
                <div class="price-list-des">
                  <div class="price-list-des-grid">
                    <span class="text-blue"> 男性 </span>
                    <template v-if="state.price[0] === '通常料金'"> 12,000円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 12,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">6,000</span>円<br />
                        3ヶ月目以降 12,000円<br />
                      </div>
                    </template>
                  </div>
                  <div class="price-list-des-grid">
                    <span class="text-pink"> 女性 </span>
                    <template v-if="state.price[0] === '通常料金'"> 10,000円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 10,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">5,000</span>円<br />
                        3ヶ月目以降 10,000円<br />
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <li v-if="state.price[0] != 'デイタイムキャンペーン'" class="price-list-item">
                <div class="price-list-title">月4回会員</div>
                <div class="price-list-des">
                  <div class="price-list-des-grid">
                    <span class="text-blue"> 男性 </span>
                    <template v-if="state.price[0] === '通常料金'"> 6,500円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 6,500円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">3,250</span>円<br />
                        3ヶ月目以降 6,500円<br />
                      </div>
                    </template>
                  </div>
                  <div class="price-list-des-grid">
                    <span class="text-pink"> 女性 </span>

                    <template v-if="state.price[0] === '通常料金'"> 5,500円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 5,500円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">2,750</span>円<br />
                        3ヶ月目以降 5,500円<br />
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <li class="price-list-item">
                <div class="price-list-title">デイタイム会員<br />（月〜金10:00〜16:00）</div>
                <div class="price-list-des">
                  <div class="price-list-des-grid">
                    <span class="text-blue"> 男性 </span>

                    <template v-if="state.price[0] === '通常料金'"> 8,500円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 8,500円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">4,250</span>円<br />
                        3ヶ月目以降 8,500円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'デイタイムキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 <span class="text-pink2">5,880</span>円<br />
                      </div>
                    </template>
                  </div>
                  <div class="price-list-des-grid">
                    <span class="text-pink"> 女性 </span>

                    <template v-if="state.price[0] === '通常料金'"> 8,000円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 8,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">4,000</span>円<br />
                        3ヶ月目以降 8,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'デイタイムキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 <span class="text-pink2">5,880</span>円<br />
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <li v-if="state.price[0] != 'デイタイムキャンペーン'" class="price-list-item">
                <div class="price-list-title">学生会員(中学3年生まで）<br><span style="font-size: 80%;">高校生から一般会員になります。</span>
                </div>
                <div class="price-list-des">
                  <template v-if="state.price[0] === '通常料金'">
                    <div class="price-list-des-grid2">7,500円</div>
                  </template>
                  <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                    <div class="price-list-des-grid2">
                      初月 <span class="text-pink2">0</span>円<br />
                      2ヶ月目以降 7,500円<br />
                    </div>
                  </template>
                  <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                    <div class="price-list-des-grid2">
                      初月 <span class="text-pink2">0</span>円<br />
                      2ヶ月目 <span class="text-pink2">3,750</span>円<br />
                      3ヶ月目以降 7,500円<br />
                    </div>
                  </template>
                </div>
              </li>
              <li v-if="state.price[0] != 'デイタイムキャンペーン'" class="price-list-item">
                <div class="price-list-title">シルバー会員（60歳以上）</div>
                <div class="price-list-des">
                  <div class="price-list-des-grid">
                    <span class="text-blue"> 男性 </span>

                    <template v-if="state.price[0] === '通常料金'"> 8,000円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 8,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">4,000</span>円<br />
                        3ヶ月目以降 8,000円<br />
                      </div>
                    </template>
                  </div>
                  <div class="price-list-des-grid">
                    <span class="text-pink"> 女性 </span>

                    <template v-if="state.price[0] === '通常料金'"> 7,000円 </template>
                    <template v-else-if="state.price[0] === '新規入会キャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目以降 7,000円<br />
                      </div>
                    </template>
                    <template v-else-if="state.price[0] === 'のりかえキャンペーン'">
                      <div>
                        初月 <span class="text-pink2">0</span>円<br />
                        2ヶ月目 <span class="text-pink2">3,500</span>円<br />
                        3ヶ月目以降 7,000円<br />
                      </div>
                    </template>
                  </div>
                </div>
              </li>

              <li v-if="state.price[0] != 'デイタイムキャンペーン'" class="price-list-item">
                <div class="price-list-title">ビジター</div>
                <div class="price-list-des">
                  <div class="price-list-des">
                    <div class="price-list-des-grid2">3,000円 ※現金のみ</div>
                  </div>
                </div>
              </li>

              <li class="price-list-item">
                <div class="price-list-title">顔認証登録手数料</div>
                <div class="price-list-des">
                  <div class="price-list-des">
                    <template v-if="state.price[0] === '通常料金'">
                      <div class="price-list-des-grid2">2,200円</div>
                    </template>
                    <template v-else>
                      <div class="price-list-des-grid2">
                        <span class="text-pink2">0</span>円
                      </div>
                    </template>

                  </div>
                </div>
              </li>

              <li class="price-list-item">
                <div class="price-list-title">体験料</div>
                <div class="price-list-des">
                  <div class="price-list-des">
                    <div class="price-list-des-grid2">2,000円</div>
                  </div>
                </div>
              </li>

            </ul>

            <div id="price-list2" class="price-list-sub fade-in">
              <div class="top-items-title">
                <h2>Price</h2>
                <p>料金表</p>
                <div>- 貸し出し -</div>
              </div>

            </div>

            <div class="price-list-wrap fade-in">
              <ul class="price-list">

                <li class="price-list-item">
                  <div class="price-list-title">軍手</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">100円</div>
                    </div>
                  </div>
                </li>

                <li class="price-list-item">
                  <div class="price-list-title">レンタルウェア<br>（S〜LLまで）</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">300円</div>
                    </div>
                  </div>
                </li>


                <li class="price-list-item">
                  <div class="price-list-title">ハーフパンツ<br>（S〜LLまで）</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">300円</div>
                    </div>
                  </div>
                </li>

                <li class="price-list-item">
                  <div class="price-list-title">上下セットアップ</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">500円</div>
                    </div>
                  </div>
                </li>

                <li class="price-list-item">
                  <div class="price-list-title">貸し出しロッカー完備</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">月額1,500円<br>マイグローブやレガースなどジムに置いたままに出来ます。</div>
                    </div>
                  </div>
                </li>

                <li class="price-list-item">
                  <div class="price-list-title">水（500ml)</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">100円 ※販売</div>
                    </div>
                  </div>
                </li>

                <li class="price-list-item">
                  <div class="price-list-title">アクエリアス</div>
                  <div class="price-list-des">
                    <div class="price-list-des">
                      <div class="price-list-des-grid2">150円 ※販売</div>
                    </div>
                  </div>
                </li>


              </ul>
            </div>

            <div class="price-bg">
              <img src="~@/assets/img/bg/price_bg.jpg" />
            </div>
            <div class="price-bg2">
              TAKE A<br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BREATH
            </div>
          </div>


        </div>

        <div class="price-button fade-in">
          <div class="attention">
            <p>体験、見学受付中<br />こちらから</p>
          </div>

          <div class="button-wrap">
            <div class="button">
              <router-link to="/Contact" @click="onTapReturnButton">
                <div class="icon-arrow-left"></div>
                お問い合わせ
              </router-link>
            </div>
          </div>
        </div>

        <div id="flow" class="flow fade-in">
          <div class="top-items-title">
            <h2>Flow</h2>
            <p>入会の流れ</p>
          </div>
          <div>
            <div class="box26 fade-in">
              <span class="box-title">STEP 1</span>
              <span class="box-title-sub">ホームページから体験日の予約</span>
              <p>お電話・メールにてご連絡ください。</p>
            </div>
          </div>
          <div class="arrow-bottom2"></div>

          <div class="box26 fade-in">
            <span class="box-title">STEP 2</span>
            <div>
              <div>
                <span class="box-title-sub">ご来館</span>
                <p>当日のお持ち物をご持参の上、ご来館ください。
                </p>
                <p>（お持ち物はお電話・メールにてお伝えいたします。）
                </p>
              </div>
              <div> <img src="~@/assets/img/flow/2.jpg" /></div>
            </div>


          </div>
          <div class="arrow-bottom2"></div>

          <div class="box26 fade-in">
            <span class="box-title">STEP 3</span>
            <div>
              <div>
                <span class="box-title-sub">体験スタート</span>
                <p>当ジムスタッフが分かりやすくサポートいたします。
                </p>
              </div>
              <div> <img src="~@/assets/img/flow/3.jpg" /></div>
            </div>


          </div>
          <div class="arrow-bottom2"></div>

          <div class="box26 fade-in">
            <span class="box-title">STEP 4</span>
            <div>
              <div>
                <span class="box-title-sub">入会手続き</span>
                <p>入会手続きに必要な書類に記入していただきます。<br>
                  （お手続きのお時間約10分程度）
                </p>
              </div>
              <div> <img src="~@/assets/img/flow/4.jpg" /></div>
            </div>


          </div>
          <div class="arrow-bottom2"></div>

          <div class="box26 fade-in">
            <span class="box-title">STEP 5</span>
            <div>
              <div>
                <span class="box-title-sub">顔認証システムにお顔の登録</span>
                <p>ご来館・ご退館の際に必要になります。
                </p>
              </div>
              <div> <img src="~@/assets/img/flow/5.jpg" /></div>
            </div>


          </div>
          <div class="arrow-bottom2"></div>

          <div class="box26 fade-in">
            <span class="box-title">STEP 6</span>
            <div>
              <div>
                <span class="box-title-sub">お手続き完了！</span>
                <p class="text-pink2">私たちと楽しくレッスンしていきましょう！
                </p>
              </div>
              <div> <img src="~@/assets/img/flow/6.jpg" /></div>
            </div>


          </div>



        </div>


        <div class="price-button fade-in">
          <div class="attention">
            <p>体験、見学受付中<br />こちらから</p>
          </div>

          <div class="button-wrap">
            <div class="button">
              <router-link to="/Contact" @click="onTapReturnButton">
                <div class="icon-arrow-left"></div>
                お問い合わせ
              </router-link>
            </div>
          </div>
        </div>


        <div id="qa" class="qa fade-in">
          <div class="top-items-title">
            <h2>Q & A</h2>
            <p>よくある質問</p>
          </div>
          <ul class="qa-list">

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open3()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">体験・見学利用できますか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen3 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen3">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    <span>
                      営業時間内のスタッフ常駐時であれば、いつでもご見学いただけます。<br>
                      体験はフリータイム枠、キック初級クラス、レディースキッククラス、エントリーキッククラス、レディースエントリークラスのみ可能となります。<br>
                      詳しくは<router-link to="/Contact" class="qa-link">お問い合わせ</router-link>のご希望の日付をご確認いただき、お問い合わせください。<br>
                    </span>
                  </div>
                </div>
              </transition>
            </li>

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open6()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">レッスンに予約は必要ですか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen6 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen6">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    <span>
                      どのクラスも予約は入りません。クラス開催10分前までにお越しください。<br>
                      途中参加、途中退出も可能なっておりますので、お気軽にご参加くださいませ。
                    </span>
                  </div>
                </div>
              </transition>
            </li>

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open4()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">体験・見学のお時間はどのくらいですか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen4 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen4">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    <span>
                      フリータイム枠は30〜40分となっております。<br>キック初級クラス、レディースキッククラスは1時間となっております。<br>エントリーキッククラス、レディースエントリークラスは30分となっております。
                    </span>
                  </div>
                </div>
              </transition>
            </li>

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open5()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">フリータイムの体験と各クラスの体験は何をやるんですか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen5 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen5">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    <span>
                      フリータイムはトレーナーと1対1でキックボクシングの基本動作をご体験していただきます。<br>キック初級クラス、レディースキッククラスの体験は実際のレッスンを1時間、
                      エントリーキッククラス、レディースエントリークラスは30分、会員様とご一緒にご体験していただきます。
                    </span>
                  </div>
                </div>
              </transition>
            </li>


            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">入会手続き（本会員登録）に必要なものはありますか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    1.現住所が記載された本人確認書類いずれか1点<br />（免許証・保険証・パスポート・マイナンバーカード・学生証）<br />
                    2.会員費の引落口座用のクレジットカード<br />
                    ※ご本人様名義、同姓の配偶者名義に限ります。
                  </div>
                </div>
              </transition>
            </li>

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open2()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">体験時の持ち物について教えてください。</div>
                <div class="icon-arrow-bottom" :class="state.isOpen2 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen2">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    1.動きやすい格好<br />
                    2.汗拭きタオル<br />
                    3.軍手<br />
                    4.飲み物(水やスポーツドリンク)<br />
                    などをお持ちください。
                  </div>
                </div>
              </transition>
            </li>

            <li class="qa-list-item">
              <div class="qa-list-item-child" @click="open7()">
                <div class="qa-list-q text-gold">Q</div>
                <div class="qa-list-title">クレジットカードが無く、現金払いでの支払いは可能ですか？</div>
                <div class="icon-arrow-bottom" :class="state.isOpen7 ? 'active' : ''"></div>
              </div>
              <transition name="open">
                <div class="accordion-content" v-if="state.isOpen7">
                  <div class="qa-list-q text-gold">A</div>
                  <div class="qa-list-text">
                    基本的にクレジットカードのみでのお支払いとさせていただいております。特例としてクレジットカードお持ちでない方限定で現金でのお支払いもお受けしております。キャンペーンでのご入会ご希望の場合、半年一括分の会費を入会時にお納めいだだきます。半年以降の会費お支払いは3ヶ月分ずつお支払いいただきます。キャンペーン非適応でのご入会適応の方は入会金11000円、顔認証登録手数料2200円、会費3ヶ月分お支払いいただきます。
                  </div>
                </div>
              </transition>
            </li>

          </ul>
        </div>

        <div id="staff" class="staff fade-in">
          <div class="top-items-title">
            <h2>Staff</h2>
            <p>スタッフ紹介</p>
          </div>
          <ul class="member-wrap">
            <li class="fade-in">
              <router-link to="/NO1">
                <div class="memberMin">
                  <div class="pic">
                    <img src="~@/assets/img/trainers/1.jpg" />
                  </div>
                  <div class="tmName">
                    <div class="icon-arrow-left"></div>
                    <span class="name">KEISUKE MIYAMOTO</span>
                    <span class="home">宮元 啓介</span>
                    <span class="kinds">代表</span>
                  </div>
                </div>
              </router-link>
            </li>
            <li class="fade-in">
              <div class="memberMin" @click="onTapTrainerPop">
                <div class="pic">
                  <img src="~@/assets/img/trainers/2.jpg" />
                </div>
                <div class="tmName">
                  <div class="icon-arrow-left"></div>
                  <span class="name">TORA</span>
                  <span class="home">トラ</span>
                  <span class="kinds">トレーナー</span>
                </div>
              </div>
            </li>


          </ul>
        </div>

        <div id="facilittes" class="facilittes fade-in">
          <div class="top-items-title">
            <h2>Facilittes</h2>
            <p>施設紹介</p>
          </div>

          <div class="carousel-wrap">
            <Carousel v-bind="settings" :breakpoints="breakpoints" :autoplay="3000" :wrap-around="true">
              <Slide v-for="(slide, idx) in state.slides3" :key="idx">
                <div class="pic" @click="onTapFacilittes">
                  <img v-bind:src="state.slides3[idx].img" />
                  <div class="pic-text">{{ state.slides3[idx].title }}</div>
                </div>

                <!-- <div class="carousel__item">
            {{ slide[idx].img }}
             {{ slide[idx].title }}
          </div> -->
              </Slide>
            </Carousel>
          </div>

          <div class="price-button">
            <div class="button-wrap">
              <div class="button">
                <router-link to="/Facilittes">
                  <div class="icon-arrow-left"></div>
                  詳しく見る
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div id="info" class="info fade-in">
          <div class="top-items-title">
            <h2>Info</h2>
            <p>ジム案内</p>
          </div>
          <ul class="info-list">
            <li class="info-list-item">
              <div class="info-list-title">電話番号</div>
              <div class="info-list-des">
                <a href="tel:0356729860">03-5672-9860</a>
              </div>
            </li>
            <li class="info-list-item">
              <div class="info-list-title">FAX</div>
              <div class="info-list-des">03-5672-9860</div>
            </li>
            <li class="info-list-item">
              <div class="info-list-title">メールアドレス</div>
              <div class="info-list-des">
                <a href="mailto:cyclonegym.0301@gmail.com">cyclonegym.0301@gmail.com</a>
              </div>
            </li>
            <li class="info-list-item">
              <div class="info-list-title">営業時間</div>
              <div class="info-list-des">月〜金10:00〜22:00 土曜日10:00〜20:00 日曜日12:00〜18:00<br />休館日祝日</div>
            </li>
            <li class="info-list-item">
              <div class="info-list-title">SNS</div>
              <div class="info-list-des">
                <div class="waku">
                  <div class="twitter">
                    <a href="https://twitter.com/CYCLONEGYM11" target="_blank"><img class="img_1"
                        src="~@/assets/img/sns/twitter.png" /></a>
                  </div>
                  <div class="instagram">
                    <a href="https://www.instagram.com/cyclone.gym/" target="_blank"><img class="img_1"
                        src="~@/assets/img/sns/Instagram.png" /></a>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="info-bg">
            I'm Nicer<br />
            After<br />
            Kickboxing
            <img src="~@/assets/img/logo/logo_simple.png" />
          </div>
        </div>

        <div id="access" class="access fade-in">
          <div class="top-items-title">
            <h2>Access</h2>
            <p>アクセス</p>
          </div>
          <ul class="access-list">
            <li class="access-list-item">東京都葛飾区金町6-4-4 クライスビル1F</li>
            <li class="access-list-item">・JR常磐線『金町駅』から徒歩3分<br>
              ・京成金町線『京成金町駅』から徒歩6分</li>
            <li class="access-list-item">
              <div class="googlemap-bw">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.2449119631924!2d139.87153617612825!3d35.76935982512705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188574c08f86e9%3A0x5c38fd2e8ec37635!2z44CSMTI1LTAwNDIg5p2x5Lqs6YO96JGb6aO-5Yy66YeR55S677yW5LiB55uu77yU4oiS77yUIOOCr-ODqeOCpOOCueODk-ODqyAxZg!5e0!3m2!1sja!2sjp!4v1684163180166!5m2!1sja!2sjp"
                  style="border: 0" allowfullscreen="" loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </li>
          </ul>
        </div>

        <div class="price-button fade-in">
          <div class="attention">
            <p>体験、見学受付中<br />こちらから</p>
          </div>

          <div class="button-wrap">
            <div class="button">
              <router-link to="/Contact" @click="onTapReturnButton">
                <div class="icon-arrow-left"></div>
                お問い合わせ
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed, onBeforeMount, nextTick } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import { useApplicationStore } from '@/store/modules/applicationModule'
import { useRoute, useRouter } from 'vue-router'
import { NewsList } from '@/models/news'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useHistoryState, onBackupState } from 'vue-history-state'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

gsap.registerPlugin(ScrollTrigger)

interface State {
  iScrollObj: null | IScroll
  slides: any
  slides2: any
  current_slide: any
  isOpen: boolean
  isOpen2: boolean
  isOpen3: boolean
  isOpen4: boolean
  isOpen5: boolean
  isOpen6: boolean
  isOpen7: boolean
  news: any
  news2: any
  price: any
  slides3: any
  week: any
  isSP: boolean
  currenPage: any
}

export default defineComponent({
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    // carousel settings
    settings: {
      itemsToShow: 1,
      snapAlign: 'center',
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      1: {
        itemsToShow: 1.5,
        snapAlign: 'center',
      },
      700: {
        itemsToShow: 2.5,
        snapAlign: 'center',
      },
      // 1024 and up
      1024: {
        itemsToShow: 3.5,
        snapAlign: 'start',
      },
    },
  }),
  setup() {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const route = useRoute()
    const router = useRouter()
    const state = reactive<State>({
      iScrollObj: null,
      slides: [
        { img: require('@/assets/img/topViwe/1.jpg') },
        { img: require('@/assets/img/topViwe/2.jpg') },
        { img: require('@/assets/img/topViwe/3.jpg') },
        { img: require('@/assets/img/topViwe/4.jpg') },
      ],
      slides2: [
        { img: require('@/assets/img/topViwe/sp1.jpg') },
        { img: require('@/assets/img/topViwe/sp2.jpg') },
        { img: require('@/assets/img/topViwe/sp3.jpg') },
        { img: require('@/assets/img/topViwe/4.jpg') },
      ],
      current_slide: null,
      isOpen: false,
      isOpen2: false,
      isOpen3: false,
      isOpen4: false,
      isOpen5: false,
      isOpen6: false,
      isOpen7: false,
      news: null,
      news2: null,
      price: ['通常料金'],
      slides3: [
        { img: require('@/assets/img/facilittes/1-top.jpg'), title: 'フロント' },
        { img: require('@/assets/img/facilittes/2.jpg'), title: '入り口' },
        { img: require('@/assets/img/facilittes/3.jpg'), title: 'リング' },
        { img: require('@/assets/img/facilittes/4.jpg'), title: 'サンドバック' },
        { img: require('@/assets/img/facilittes/5-top.jpg'), title: '筋トレエリア' },
        { img: require('@/assets/img/facilittes/6.jpg'), title: '女子更衣室' },
        { img: require('@/assets/img/facilittes/7.jpg'), title: '男子更衣室' },
        { img: require('@/assets/img/facilittes/8.jpg'), title: '顔認証システム搭載' },
        { img: require('@/assets/img/facilittes/9-top.jpg'), title: '化粧室' },
      ],
      week: ['月曜日'],
      isSP: false,
      currenPage: null
    })

    state.news2 = NewsList


    // var isCurrentPage = sessionStorage.getItem('isCurrentPage')
    // if (isCurrentPage) {
    //   state.currenPage = isCurrentPage
    // } else {
    //    state.currenPage = 1
    // }


    // state.news = NewsList.slice(0,5)

    const prevButton = () => {
      //  state.news = NewsList.slice(5,10)
      state.currenPage -= 1

      viweNews()

    }

    const nextButton = () => {


      console.log('next')
      //  state.news = NewsList.slice(5,10)

      state.currenPage += 1

      viweNews()

    }


    const setCurrentPage = () => {


      sessionStorage.setItem("isCurrentPage", state.currenPage)

    }


    const viweNews = () => {



      const t = state.currenPage * 5
      const t2 = t - 5


      state.news = NewsList.slice(t2, t)



    }

    var isCurrentPage = Number(sessionStorage.getItem('isCurrentPage'))
    if (isCurrentPage) {
      state.currenPage = isCurrentPage
    } else {
      state.currenPage = 1
    }



    const isButtonActive = (str) => {



      let result

      if (str == "prev") {
        if (state.currenPage === 1) {
          result = true
        } else {
          result = false
        }
      } else {
        if (Math.ceil(state.news2.length / 5) === state.currenPage) {
          result = true
        } else {
          result = false
        }
      }



      return result
    }

    //    const hogeList = async function () {
    //   await nextTick()

    //    var positionY = sessionStorage.getItem('positionY')
    //   scrollTo(0, Number(positionY));
    //   setTimeout(function () {
    //     scrollTo(0, Number(positionY));
    //   }, 0);
    // }

    // hogeList()

    const shouldShowTopPanel = computed(() => ApplicationStore.getShouldShowTopPanel)

    const onTapReturnButton = () => {
      const target = document.getElementsByClassName('wrapper')
      target[0].classList.remove('active')
      setTimeout(() => {
        target[0].classList.add('active')
      }, 300)
    }

    const open = () => {
      state.isOpen = !state.isOpen
    }

    const open2 = () => {
      state.isOpen2 = !state.isOpen2
    }

    const open3 = () => {
      state.isOpen3 = !state.isOpen3
    }

    const open4 = () => {
      state.isOpen4 = !state.isOpen4
    }

    const open5 = () => {
      state.isOpen5 = !state.isOpen5
    }

    const open6 = () => {
      state.isOpen6 = !state.isOpen6
    }

    const open7 = () => {
      state.isOpen7 = !state.isOpen7
    }


    const onTapReturnButton2 = () => {
      ApplicationStore.UPD_TOP_PANEL(false)
      ApplicationStore.UPD_TOP_PANEL3(true)
    }

    const onTapFacilittes = () => {
      router.push('/Facilittes')
    }

    const selectPrice = (evt) => {
      // console.log(evt)
      state.price[0] = evt
    }

    const selectWeek = (evt) => {
      state.week[0] = evt
    }

    const isCheckedProduct = (str) => {
      return state.price.includes(str)
    }

    const isCheckedProduct2 = (str) => {
      return state.week.includes(str)
    }

    const myFunc = function () {
      const target = document.getElementsByClassName('price-item-des-numtext')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc2 = function () {
      const target = document.getElementsByClassName('arrow-bottom')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc201 = function () {
      const target = document.getElementsByClassName('arrow-bottom2')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc5 = function () {
      const target = document.getElementsByClassName('fade-right')
      const target2 = document.getElementById('video')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
          if (target2) {
            target2.classList.remove('active')
          }
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc6 = function () {
      const target = document.getElementsByClassName('fade-in')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc3 = function () {
      const target = document.getElementsByClassName('price-item-des-numtext2-wrap')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc4 = function () {
      const target = document.getElementById('title')
      const target2 = document.getElementById('video')
      const position = Math.floor(window.innerHeight * 0.75)

      if (target && target2) {
        let offsetTop = Math.floor(target.getBoundingClientRect().top)
        let offsetBottom = Math.floor(target.getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target.classList.add('active')
          target2.classList.add('active')
        }

        if (offsetBottom < 0) {
          target.classList.remove('active')
          target2.classList.remove('active')
        }
      }
    }

    const myFunc7 = function () {
      const target = document.getElementsByClassName('under-line-animation')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    window.addEventListener('scroll', async function () {
      myFunc(), false

      myFunc2(), false

      myFunc3(), false

      myFunc4(), false

      myFunc5(), false

      myFunc6(), false

      myFunc7(), false
      myFunc201(), false
    })


    function isSmartPhone() {
      // デバイス幅が640px以下の場合にスマホと判定する
      if (window.matchMedia && window.matchMedia('(max-device-width: 767px)').matches || window.innerWidth < 768) {
        state.isSP = true
      } else {
        state.isSP = false
      }
    }

    window.addEventListener('resize', async function () {
      // myFunc(), false

      isSmartPhone()

    })


    // onMounted(() => {

    //   const titems = document.querySelector(".pin-spacer");

    //   if (titems) {
    //     // console.log('ari');

    //     // while (titems.firstChild) {
    //     //   titems.parentNode.insertBefore(titems.firstChild, titems);
    //     // }

    //     // titems.parentNode.removeChild(titems);
    //     state.iScrollObj.kill()
    //   }

    //     setTimeout(() => {

    //       const areawrap = document.querySelector(".area-wrap");
    //       areawrap.removeAttribute('style')
    //       const area = document.querySelector(".js-area");
    //       area.removeAttribute('style')
    //       const wrap = document.querySelector(".js-wrap");
    //       wrap.removeAttribute('style')
    //       const items = document.querySelectorAll(".js-item");
    //       const num = items.length;
    //       console.log(items);

    //       items.forEach(element => {
    //         element.removeAttribute('style')
    //       });

    //       gsap.set(wrap, { width: num * 100 + "%" });
    //       gsap.set(items, { width: 100 / num + "%" });

    //       state.iScrollObj = gsap.to(items, {
    //         //アニメーションしたい要素を指定
    //         xPercent: -100 * (num - 1), //x方向に移動させる
    //         ease: "none",
    //         scrollTrigger: {
    //           trigger: area, //トリガー
    //           start: "top top", //開始位置
    //           end: "+=3000", //終了位置
    //           pin: true, //ピン留め
    //           scrub: true, //スクロール量に応じて動かす
    //           invalidateOnRefresh: true
    //         },
    //       });

    //       if (state.iScrollObj) {
    //         state.iScrollObj.scrollTrigger.refresh()
    //       }
    //     }, 0)

    //     })


    onMounted(() => {

      viweNews()
    })



    // var isCurrentPage = sessionStorage.getItem('isCurrentPage')
    // if (isCurrentPage) {
    //   state.currenPage = isCurrentPage
    // } else {
    //   state.currenPage = 1
    // }
    // viweNews()


    window.addEventListener('pageshow', async function () {
      // const titems = document.querySelector(".pin-spacer");

      // if (titems) {
      //   console.log('ari');

      //   while (titems.firstChild) {
      //     titems.parentNode.insertBefore(titems.firstChild, titems);
      //   }

      //   titems.parentNode.removeChild(titems);
      // }
      const target = document.getElementsByClassName('wrapper')
      target[0].classList.add('active')

    })

    isSmartPhone()

    const historyState = useHistoryState()
    console.log(historyState)

    // window.addEventListener('load', async function () {
    //   myF()

    // })

    // window.addEventListener('popstate', async function () {
    //   const tl = myF()
    //   console.log(tl);

    //   tl.scrollTrigger.refresh()

    // })

    setTimeout(() => {
      if (state.current_slide === null) {
        state.current_slide = 0
      }
    }, 300)

    setInterval(() => {
      state.current_slide = state.current_slide < state.slides.length - 1 ? state.current_slide + 1 : 0
      console.log(state.current_slide)
    }, 8000)

    const shouldShowTopPanel4 = computed(() => ApplicationStore.getShouldShowTopPanel4)

    const onTapTrainerPop = () => {


      console.log(shouldShowTopPanel4)
      ApplicationStore.UPD_TOP_PANEL4(true)
    }

    const onTapTrainerPop2 = () => {
      ApplicationStore.UPD_TOP_PANEL5(true)
    }



    return {
      root,
      state,
      route,
      onTapReturnButton,
      onTapReturnButton2,
      open,
      open2,
      open3,
      open4,
      open5,
      open6,
      open7,
      selectPrice,
      selectWeek,
      isCheckedProduct,
      isCheckedProduct2,
      onTapFacilittes,
      onTapTrainerPop,
      onTapTrainerPop2,
      prevButton,
      nextButton,
      isButtonActive,
      setCurrentPage
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

@font-face {
  font-family: 'mafw';
  src: url('~@/assets/fonts/mafw.ttf') format('truetype');
}


div {
  font-size: 1.4rem;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.call {
  color: rgb(88, 87, 76);

  a {
    color: rgb(88, 87, 76);
  }
}

p {
  font-family: 'Shippori Mincho', serif;
  color: rgb(88, 87, 76);
}

img {
  width: 100%;
}

.pc-none {
  display: none;

  &-inline {
    display: none;
  }
}

.text-pink {
  color: #ffb4ec;
}

.text-pink2 {
  color: #ff4081;
}

.text-gold {
  color: #ada554;
}

.text-blue {
  color: #4288c6;
}

.slider-outer {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0 auto 20px;
}

.slider-inner {
  position: relative;
  width: 100%;
  height: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 2;
  }
}

.slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  opacity: 0;
  transform: scale(1.1);

  &.active {
    transition: transform 8000ms ease-out 0s, opacity 800ms ease 0s;
    opacity: 1;
    transform: scale(1.2);
  }
}

.slider-text {
  position: absolute;

  color: #fff;
  font-size: 10rem;
  letter-spacing: 1.8px;
  font-family: 'Shippori Mincho', serif;
  z-index: 3;

  &1 {
    top: 30%;
    left: 25%;
    font-size: 10rem;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
  }

  &2 {
    top: 55%;
    right: 15%;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
  }

  &3 {
    top: 45%;
    left: 5%;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
  }

  &4 {
    font-size: 6rem;
    top: 15%;
    right: 5%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 800ms ease 0s;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: transform 8000ms ease-out 0s;
  transform: scale(1.2);
}

.fade-enter-to {
  transform: scale(1.1);
}

.over-ray {
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  position: absolute;
  top: 0;
}

.title-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  flex-direction: column;
  margin-bottom: 120px;
  font-weight: 900;
  margin-top: -100px;

  @media (orientation: landscape) {
    height: 100%;
    margin-top: 0;
  }

  & h1 {
    font-size: 4rem;
    font-weight: 900;
    line-height: 1;
  }

  & h2 {
    font-size: 3rem;
    font-weight: 900;
  }
}

#title {
  text-align: center;
}

.top-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;

  &-img {
    max-width: 500px;
    width: 100%;
    touch-action: inherit;
  }
}

.TopPage .top-content {
  position: relative;
  z-index: 3;
  font-family: 'Shippori Mincho', serif;
}

.top-content-des {
  margin-bottom: 40px;

  p {
    font-size: 1.4rem;
  }
}

.top-content-head {
  position: relative;
  padding-bottom: 140px;
  // pointer-events: none;
  z-index: 2;
  padding-top: 100px;
}

.top-content-primary {
  padding-left: 4.4%;
  padding-right: 4.4%;
}

.top-content-head .top-content-headTitle {
  position: relative;
  width: 60%;
  z-index: 2;
}

.top-content-head .top-content-headTitle .top-content-headTitleRead {
  bottom: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;
  position: absolute;
  right: -12vw;
}

.head-title {
  color: #fff;
  font-size: 8rem;
  font-family: 'Montserrat', sans-serif;
}

.concept {
  position: relative;

  &-bg {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.1;
    position: absolute;
    right: 0;
    bottom: -80px;
  }
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.open-enter-active {
  animation: open 0.2s;
}

.open-leave-active {
  animation: open 0.2s linear reverse;
}

.facilittes {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;

  // display: flex;
  // flex-wrap: wrap;
  & .top-items-title {
    text-align: left;
  }

  & .carousel {
    margin: 0 calc(50% - 50vw);
    width: 100vw;

    & .pic {
      height: 100%;
      overflow: hidden;
      position: relative;
      cursor: pointer;

      &-text {
        position: absolute;
        background-color: #fff;
        bottom: 0;
        right: 0;
        padding: 5px 20px;
        font-size: 1.8rem;
      }

      img {
        transition: 1s all;
      }

      &:hover {
        img {
          transform: scale(1.2, 1.2);
          transition: 1s all;
        }
      }
    }
  }
}

.news {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;
  display: flex;
  flex-wrap: wrap;

  & .top-items-title {
    text-align: center;
    width: 20%;
  }

  &-list {
    width: 80%;

    &-item {
      border-bottom: 1px solid #c2c3cc;
      padding: 24px 0;

      a {
        display: flex;
        color: rgb(88, 87, 76);
      }
    }

    &-date {
      width: 100px;
    }

    &-title {
      text-decoration: underline;
    }
  }
}

.menu {
  font-family: 'Shippori Mincho', serif;
  margin-top: 120px;
  position: relative;

  &-list-bg {
    position: absolute;
    right: -4.4%;
    top: 123px;
    height: 750px;
    z-index: -1;
    opacity: 0.7;

    &2 {
      // display: none;
      position: absolute;
      right: -4.4%;
      top: calc(950px + 123px);
      height: 750px;
      z-index: -1;
      opacity: 0.7;
    }

    &3 {
      // display: none;
      position: absolute;
      right: -4.4%;
      top: calc(1900px + 123px);
      height: 750px;
      z-index: -1;
      opacity: 0.7;
    }

    &4 {
      display: none;
      position: absolute;
      right: -4.4%;
      top: 2500px;
      height: 750px;
      z-index: -1;
      opacity: 0.7;
    }

    &5 {
      display: none;
      position: absolute;
      right: -4.4%;
      height: 750px;
      z-index: -1;
      opacity: 0.7;
    }

    img {
      height: 100%;
    }
  }

  &-list {
    width: 100%;

    &-img {
      display: none;
      opacity: 0.7;

      img {
        width: 100%;
      }
    }

    &-wrap {
      width: 100%;
    }

    &-item {
      display: flex;
      padding: 24px 0;
      font-family: 'Shippori Mincho', serif;
    }

    &-text {
      margin-bottom: 80px;
    }

    &-des {
      max-width: 400px;
      border-bottom: 1px solid #c2c3cc;
      padding-bottom: 10px;
      width: 100%;

      & span {
        font-size: 90%;
      }
    }

    &-title {
      font-size: 1.8rem;
      margin-bottom: 10px;
    }
  }
}

.access {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;
  display: flex;
  flex-wrap: wrap;

  & .top-items-title {
    text-align: center;
    width: 20%;
  }

  &-list {
    width: 80%;

    &-item {
      border-bottom: 1px solid #c2c3cc;
      padding: 24px 0;

      a {
        display: flex;
        color: rgb(88, 87, 76);
      }
    }

    &-date {
      width: 100px;
    }

    &-title {
      text-decoration: underline;
    }
  }

  .googlemap-bw {}

  .googlemap-bw iframe {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    width: 100%;
    height: 400px;
    aspect-ratio: 16/9; //アスペクト比（縦横比）を指定
  }
}

.price {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;
  font-size: 1.8rem;
  position: relative;

  & .top-items-title {
    text-align: center;
    margin: 0 auto;
  }

  &-cam {
    max-width: 1000px;
    margin: 0 auto;

    &-item {
      &:nth-child(1) {
        margin-right: 20px;
      }

      &-wrap2 {
        width: 100%;
        margin-bottom: 40px;

        .price-cam-item {
          margin: 0 auto;
        }
      }

      &:nth-child(3) {
        width: 100%;
        margin: 40px auto 0;
      }

      &-wrap {
        display: flex;
        flex-wrap: wrap;
      }

      max-width: 480px;
      width: 48%;
      box-shadow: -1px 19px 31px -17px #777777;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 40px;
      margin-bottom: 40px;

      &-title {
        background-color: $sub;
        color: #fff;
        width: 100%;
        position: relative;
        text-align: center;
        padding: 30px 5px;
        font-weight: bold;

        &::after {
          width: 0;
          height: 0;
          position: absolute;
          top: 100%;
          left: 50%;
          margin: 0 0 0 -25px;
          border: 25px solid transparent;
          border-top-color: $sub;
          content: '';
        }
      }

      &-des {
        padding: 45px 10px 40px;

        &-title {
          font-size: 2.4rem;
          text-align: center;
          color: #ff4081;
          font-weight: bold;
        }

        &-text {
          margin-top: 12px;
          font-size: 2rem;
          text-align: center;

          & span.fw {
            color: #ff4081;
            font-weight: bold;
          }

          & span.fb {
            font-size: 40px;
          }

          .fwra {
            margin-bottom: 15px;
          }

        }
      }

      & .button-wrap {
        height: 75px;
        margin: 0;
        display: flex;
        justify-content: center;
        padding: 0 5%;
      }

      & .button {
        & a {
          line-height: 1.333;
        }
      }

      &-note {
        padding-top: 20px;
        font-size: 1.2rem;

        &-title {
          font-weight: bold;
        }
      }
    }

    .attention {
      &-wrap {
        text-align: center;
        margin-bottom: 20px;
      }

      p {
        font-size: 2rem;
        font-weight: 600;
        text-align: center;
      }
    }
  }

  &-list {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;



    &-wrap {
      position: relative;

      & .price-bg {
        opacity: 0.1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        z-index: -1;
        width: 100%;
        max-width: 1000px;

        &2 {
          display: none;
          font-family: 'mafw';
          font-size: 6rem;
          opacity: 0.1;
          position: fixed;
          left: 40px;
          top: 100px;
          z-index: -1;
        }

      }

    }

    &-item {
      display: flex;
      color: rgb(88, 87, 76);
      border-bottom: 1px solid #c2c3cc;
      padding: 24px 0;
      align-items: center;
    }

    &-sub {
      max-width: 1000px;
      width: 100%;
      margin: 80px auto 0;

      h2+p {
        margin-bottom: 5px;
      }

      .checkbox-list {
        cursor: pointer;
        display: flex;
        width: 100%;
        justify-content: flex-end;

        .checkbox__item {
          font-size: 1.1rem;
          width: 170px;
          border: 1px solid #c2c3cc;
          border-radius: 25px;
          padding: 10px 5px;
          display: flex;
          justify-content: center;
          letter-spacing: 1.5px;
          margin-left: 10px;

          &.on {
            background-color: #ff4081;
            border: 1px solid #ff025a;
            color: #fff;
          }
        }

        &-text {
          font-size: 1.4rem;
          text-align: right;
          margin: 40px 0 10px;
        }
      }
    }

    &-title {
      width: 375px;
    }

    &-des {
      display: flex;
      width: 100%;

      & .text-pink2 {
        padding-right: 8px;
        font-weight: bold;
      }

      &-grid {
        width: 50%;
        display: flex;

        &>span {
          margin-right: 10px;
        }
      }
    }
  }
}

.lesson {
  font-family: 'Shippori Mincho', serif;
  margin-top: 0px;
  font-size: 1.8rem;
  position: relative;

  & a {
    color: rgb(88, 87, 76);
  }

  &-bg {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.1;
    position: absolute;
    right: 50%;
    bottom: 280px;
    z-index: -1;
  }

  &-bg2 {
    opacity: 0.1;
    position: absolute;
    right: 35%;
    bottom: -115px;
    z-index: -1;
  }

  & .top-items-title {
    text-align: center;
    margin: 0 auto;
  }

  .checkbox-list {
    cursor: pointer;
    display: flex;
    width: 100%;
    justify-content: center;
    max-width: 380px;
    flex-wrap: wrap;
    margin: 0 auto;

    .checkbox__item {
      font-size: 1.2rem;
      width: 70px;
      border: 1px solid #c2c3cc;
      border-radius: 25px;
      padding: 10px;
      display: flex;
      justify-content: center;
      letter-spacing: 1.5px;
      margin: 0 5px 10px;

      &.on {
        background-color: #ff4081;
        border: 1px solid #ff025a;
        color: #fff;
      }
    }

    &-text {
      font-size: 1.4rem;
      text-align: center;
      margin: 40px 0 10px;
    }
  }

  &-schedule-note {
    display: none;

    &2 {
      display: none;
      margin-top: 10px;
    }
  }

  &-schedulebox {
    & p {
      font-size: 1.3rem;
      text-align: center;
      margin-bottom: 0;

      & .sm {
        font-size: 70%;
      }

      & span.keep {
        word-break: keep-all;
      }
    }

    &-wrap {
      overflow-x: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    width: 100%;
    margin: 0 auto;
    padding: 0 1%;
    /* box-sizing: content-box; */
    // min-width: 900px;
    max-width: 1200px;

    & ul {
      display: flex;
      width: 100%;
      padding-left: 0;

      & li {
        width: 100%;
        position: static;
        left: 0;

        &.hours {
          & dd {
            border-left: 1px solid #333333;
            background-color: #fafafa;
          }
        }

        &.sunday {
          & dt {
            border-right: none;
          }
        }

        & dl {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          dt,
          dd {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
          }

          & dt {
            height: 70px;
            background: #333333;
            border-right: 1px solid #fff;
            color: #fff;
            font-weight: bold;
            font-size: 1.6rem;
          }

          & dd {
            height: 100px;
            border-right: 1px solid #333333;
            border-bottom: 1px solid #333333;
            position: relative;
            margin-bottom: 0;

            &.classRhythm {
              background-color: #e3eaf6;
            }

            &.classRhythmClub {
              background-color: #e8e4f6;
            }

            &.classBiginer {
              background-color: #f7f8e1;
            }

            &.classBiginer2 {
              background-color: #CFCFCF;
            }

            &.classEntry {
              background-color: #FBFBF0;
            }

            &.classLadies {
              background-color: #FF8989;
            }

            &.classLadiesEntry {
              background-color: #ffe2e2;
            }

            &.classFit {
              background-color: #f6fb8e;
            }

            &.classRegi {
              background-color: #deffe3;
            }

            &.classRegi2 {
              background-color: #68ff7f;
            }

            &.classYOGA {
              background-color: #fff0fb;
              line-height: 1.1;
            }

            &.classSPA {
              background-color: #F2F2F2;
            }

            & .classStrengthen {
              background-color: #eebbbb;
            }

            &.classFat {
              background-color: #fcd997;
            }

            & .sub-text {
              margin: 5px;
              font-size: 1.2rem;
            }

            &.row-2 {
              height: calc(100px * 2) !important;
            }

            &.row-flex {
              flex-direction: row;
              line-height: 1.1;

              &>div {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 50%;
              }

              .classStudent {
                justify-content: flex-start;

                &>div {
                  height: 150px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  background-color: #D2EFFA;

                  & .sub-text {
                    font-size: 70%;
                  }
                }
              }
            }

            &.row-3 {
              height: calc(100px * 3) !important;
            }

            &.row-4 {
              height: calc(100px * 4) !important;
            }

            &.row-5 {
              height: calc(100px * 5) !important;
            }


            &.row-05 {
              height: 50px !important;

              p {
                line-height: 1.2;
              }

              +.row-1-05 {
                height: calc(50px * 2 + 50px) !important;
              }

              +.row-2-05 {
                height: calc(100px * 2 + 50px) !important;
              }

              +.row-3-05 {
                height: calc(100px * 3 + 50px) !important;
              }

              +.row-5-05 {
                height: calc(100px * 5 + 50px) !important;
              }
            }

            &.row-6 {
              height: calc(100px * 6) !important;
            }

            &.row-7 {
              height: calc(100px * 7) !important;
            }

            &.row-close {
              background-color: #e6e6e6;
              font-size: 1.6rem;
            }
          }
        }
      }
    }
  }
}

.info {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;
  font-size: 1.8rem;
  position: relative;

  & a {
    color: rgb(88, 87, 76);
  }

  &-bg {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.1;
    position: absolute;
    right: -4%;
    bottom: -20%;
    z-index: -1;

    img {
      max-width: 400px;
      width: 72%;
    }
  }

  &-bg2 {
    opacity: 0.1;
    position: absolute;
    right: 35%;
    bottom: -115px;
    z-index: -1;
  }

  & .top-items-title {
    text-align: center;
    margin: 0 auto;
  }

  &-list {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;

    &-item {
      display: flex;
      color: rgb(88, 87, 76);
      border-bottom: 1px solid #c2c3cc;
      padding: 24px 0;
      align-items: center;
    }

    &-title {
      width: 375px;
    }

    &-des {
      display: flex;
      width: 100%;

      & div {
        width: 50%;

        & span {
          margin-right: 10px;
        }
      }
    }
  }
}

.staff {
  font-family: 'Shippori Mincho', serif;
  margin-top: 240px;
  font-size: 1.8rem;
  position: relative;

  &-bg {
    opacity: 0.1;
    position: absolute;
    left: 0;
    bottom: -200px;
  }

  & .top-items-title {
    text-align: center;
    margin: 0 auto;
  }

  &-list {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;

    &-item {
      display: flex;
      color: rgb(88, 87, 76);
      border-bottom: 1px solid #c2c3cc;
      padding: 24px 0;
      align-items: center;
    }

    &-title {
      width: 375px;
    }

    &-des {
      display: flex;
      width: 100%;

      & div {
        width: 50%;

        & span {
          margin-right: 10px;
        }
      }
    }
  }
}

.qa {
  font-family: 'Shippori Mincho', serif;
  font-size: 1.8rem;
  margin-top: 240px;
  display: flex;
  flex-wrap: wrap;

  & .top-items-title {
    text-align: center;
    width: 20%;
  }

  &-link {
    color: #ada554;
    text-decoration: underline;
  }

  &-list {
    width: 80%;

    &-item {
      color: rgb(88, 87, 76);
      border-bottom: 1px solid #c2c3cc;

      &-child {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 24px 0;
      }
    }



    &-q {
      width: 50px;
      font-weight: 700;
    }

    &-title {
      text-decoration: underline;
    }
  }

  & .accordion-content {
    padding-bottom: 24px;

    display: flex;
  }

  & .icon-arrow-bottom {
    right: 15px;
    top: -15px;
    width: 30px;
    height: 30px;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    margin-left: 30px;

    &.active {
      &:after {
        transform: translateY(8px) rotate(225deg);
      }
    }

    &:after {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: -7.5px;
      margin-top: 7.5px;
      border-bottom: 1px solid rgb(88, 87, 76);
      border-right: 1px solid rgb(88, 87, 76);
      transform: rotate(45deg);
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
    }
  }
}

.head-subtitle-wrap {
  margin-top: 120px;
  width: 100%;
  position: relative;

  & .price-item-des-wrap-one .price-item-des {
    margin-top: 0;
  }

  & .price-item-des-wrap {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    & .price-item-des-title {
      font-size: 30px;
    }

    & .arrow-bottom {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 40px;
      border-bottom: 4px solid #fff;
      border-right: 4px solid #fff;
      transform: translateX(-100%) rotate(-45deg);
      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        transform: translateX(0) rotate(-45deg);
        opacity: 1;
      }
    }
  }
}

.head-subtitle-bottomwrap {
  display: flex;
  flex-direction: column;
  align-items: center;

  .head-subtitle {
    text-align: center;
    color: #fff;
    font-size: 6rem;
  }
}

.head-subtitle {
  color: #fff;
  background-color: $sub;
  display: inline-block;
  padding: 5px;
  font-size: 4rem;
  font-weight: 900;
}

.js-inViewAct {
  animation: inViewActKey 1s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.4, 0.005, 0.14, 1);
  backface-visibility: hidden;
  transform-origin: left top;
  will-change: transform;
}

.top-white {
  background-color: #fff;
  position: relative;
  z-index: 3;
}

.top-black {
  // background-color: $main;
  color: #fff;
  position: relative;
  z-index: 3;
}

.price-item-des2 {
  text-align: center;
}

.arrow-bottom {
  // display: inline-block;
  // display: inline-block;
  vertical-align: middle;
  color: #ff4081;
  line-height: 1;
  position: relative;
  width: 4px;
  height: 40px;
  background: currentColor;
  transform: translateY(-100%) rotate(0deg);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;
  margin: 30px auto;

  &::before {
    content: '';
    width: 18px;
    height: 18px;
    border: 4px solid currentColor;
    border-top: 0;
    border-right: 0;
    transform: rotate(-45deg);
    transform-origin: bottom left;
    position: absolute;
    left: 50%;
    bottom: -5px;
    box-sizing: border-box;
  }

  &.active {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
}

.contact-button {
  width: 300px;
  height: 100px;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 5px -5px 47px #b0b0b0, -5px 5px 47px #ffffff;

  // &-wrap {
  //   border-radius: 21px;
  //     background: #ffffff;
  //     box-shadow: inset 5px 5px 10px #666666,
  //       inset -5px -5px 10px #ffffff;
  // }
}

.fade-right {
  transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.fade-in-text {
    font-size: 26px;

    :nth-of-type(2) {
      opacity: 0;
      -webkit-transition: all 1.5s;
      -moz-transition: all 1.5s;
      -ms-transition: all 1.5s;
      -o-transition: all 1.5s;
      transition: all 1.5s;
    }

    :nth-of-type(3) {
      opacity: 0;
      -webkit-transition: all 2s;
      -moz-transition: all 2s;
      -ms-transition: all 2s;
      -o-transition: all 2s;
      transition: all 2s;
    }

    :nth-of-type(4) {
      opacity: 0;
      -webkit-transition: all 2.5s;
      -moz-transition: all 2.5s;
      -ms-transition: all 2.5s;
      -o-transition: all 2.5s;
      transition: all 2.5s;
    }

    :nth-of-type(5) {
      opacity: 0;
      -webkit-transition: all 3s;
      -moz-transition: all 3s;
      -ms-transition: all 3s;
      -o-transition: all 3s;
      transition: all 3s;
    }

    :nth-of-type(6) {
      opacity: 0;
      -webkit-transition: all 3.5s;
      -moz-transition: all 3.5s;
      -ms-transition: all 3.5s;
      -o-transition: all 3.5s;
      transition: all 3.5s;
    }
  }

  &.active {
    opacity: 1;

    &.fade-in-text {
      :nth-of-type(2) {
        opacity: 1;
      }

      :nth-of-type(3) {
        opacity: 1;
      }

      :nth-of-type(4) {
        opacity: 1;
      }

      :nth-of-type(5) {
        opacity: 1;
      }

      :nth-of-type(6) {
        opacity: 1;
      }
    }
  }
}

.under-line-animation {
  background-image: linear-gradient(120deg, #f29888 0%, $sub 100%);
  background-repeat: no-repeat;
  background-size: 0% 0.2em;
  background-position: 0 88%;
  transition: background-size 0.7s ease-in;

  &.active {
    background-size: 100% 0.2em;
  }
}

.member-wrap {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  & li {

    &:first-child {
      width: 100%;
      display: flex;
      justify-content: center;
      max-width: 100%;
    }

    &:nth-child(2) {
      margin-right: 10px;
    }

    &:nth-child(3) {
      margin-left: 10px;
    }

    max-width: 378px;
    margin-bottom: 80px;

    img {
      transition: 1s all;
    }

    &:hover {
      img {
        transform: scale(1.2, 1.2);
        transition: 1s all;
      }

      & .icon-arrow-left {
        background-color: #ada554;
      }
    }

    & .memberMin {
      max-width: 578px;
    }

    & .pic {
      height: 100%;
      overflow: hidden;
    }

    & .tmName {
      position: relative;
      display: block;
      font-size: 1.2rem;
      line-height: 2em;
      letter-spacing: 0.04em;
      background-color: #fff;
      text-align: center;
      color: #333;
      width: 85%;
      z-index: 99999;
      padding: 5% 0;
      margin: -20px auto 0;
      box-shadow: -1px 19px 31px -17px #777777;
    }

    & .icon-arrow-left {
      position: absolute;
      right: -15px;
      top: 40%;
      width: 30px;
      height: 30px;
      background-color: #ada554;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &:hover {
        &:after {
          transform: translateX(-8px) rotate(-45deg);
        }
      }

      &:after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-left: -7.5px;
        margin-top: 7.5px;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(-45deg);
        -webkit-transition: all 1s;
        -moz-transition: all 1s;
        -ms-transition: all 1s;
        -o-transition: all 1s;
        transition: all 1s;
      }
    }

    & .name {
      position: relative;
      display: block;
      font-size: 1.4rem;
      font-weight: 700;
    }

    & .home {
      position: relative;
      display: block;
    }

    & .kinds {
      display: block;
      margin-top: 5px;
      width: 100%;
    }
  }
}

.button {
  font-family: 'Shippori Mincho', serif;
  position: relative;
  display: flex;
  font-size: 2rem;
  line-height: 2em;
  letter-spacing: 0.04em;
  background-color: #ada554;
  text-align: center;
  color: #fff;
  max-width: 300px;
  width: 100%;
  z-index: 99999;
  height: 100%;
  justify-content: center;
  align-items: center;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;
  box-shadow: -1px 19px 31px -17px #777777;

  a {
    color: #fff;
    font-size: 1.8rem;
    line-height: 2em;
    width: 100%;
    font-weight: 500;
  }

  &:hover {
    letter-spacing: 0.24em;

    & .icon-arrow-left {
      transform: translateX(3px);
    }
  }

  &-wrap {
    height: 100px;
    margin: 0px 0 80px;

    &.black {
      .button {
        background-color: $main;
        color: #fff;
      }

      .icon-arrow-left {
        background-color: #fff;

        &:hover {
          &:after {
            transform: translateX(-18px) rotate(-45deg);
          }
        }

        &:after {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-left: -7.5px;
          margin-top: 7.5px;
          border-bottom: 2px solid $main;
          border-right: 2px solid $main;
          transform: rotate(-45deg);
          -webkit-transition: all 1s;
          -moz-transition: all 1s;
          -ms-transition: all 1s;
          -o-transition: all 1s;
          transition: all 1s;
        }
      }
    }
  }

  & .icon-arrow-left {
    position: absolute;
    right: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &:after {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: -7.5px;
      margin-top: 7.5px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(-45deg);
    }
  }
}

.access-wrap {
  &-grid {
    margin-bottom: 56px;
  }

  &-item {
    &.title {
      font-size: 2.4rem;
      font-weight: bold;
      letter-spacing: 0.05em;
      font-family: 'Montserrat', sans-serif;
    }

    &.des {
      font-size: 1.4rem;
      letter-spacing: 0.05em;
    }
  }
}

.container {
  position: relative;
  margin: 70px auto;
  // width: 90%;
  perspective: 1000px;
}

.container .title {
  position: absolute;
  top: -3.5rem;
  width: 100%;
  z-index: 10;
  font-size: 2.5rem;
  text-align: center;
}

.container .title p {
  position: relative;
  display: inline-block;
  width: min-content;
  font-size: 2rem;
}

.box {
  position: absolute;
  top: 90%;
  left: 15%;
  display: inline-block;
  width: 70%;
  height: 3px;
  border-radius: 50%;
  background-color: rgb(88, 87, 76);
  filter: blur(5px);
}

/* 立方体 */
.cube {
  position: relative;
  margin: 30px auto;
  width: 300px;
  height: 300px;
  transform-style: preserve-3d;
  /* 子要素を3D空間 */
  animation: rotate 20s linear infinite;
  margin-left: 200px;

  &-wrap {
    margin-right: 120px;
  }

  & img {
    width: auto;
    height: 300px;
    transition: all 1s ease;
    opacity: 1;
  }
}



@keyframes rotate {
  from {
    transform: rotateX(-10deg) rotateY(20deg);
  }

  to {
    transform: rotateX(-10deg) rotateY(-340deg);
  }
}

.cube:hover {
  animation-play-state: paused;
  /* 回転一時停止 */
}

.cube li {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.top {
  transform: translate3d(0, -150px, 0) rotateX(90deg);
  background-color: #fff;
  opacity: 0.7;
}

.front {
  transform: translate3d(0, 0, -150px);
}

.right {
  transform: translate3d(-150px, 0, 0) rotateY(90deg);
}

.back {
  transform: translate3d(0px, 0px, 150px) rotateY(180deg);
}

.left {
  transform: translate3d(150px, 0, 0) rotateY(-90deg);
}

.image-box {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.image-box:hover img {
  // transform: translateY(-200px);
}

.image-box:hover p {
  z-index: 1;
}

.access-cont {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1280px;
  margin: 0 auto;
}

.waku {
  display: flex;

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
    margin-right: 15px;

    & a {
      display: flex;
    }
  }

  & img {
    max-width: 20px;
    height: auto;
    width: 100%;
    -webkit-filter: grayscale(1);
    filter: $main;
    filter: grayscale(1);
  }

  & img:hover {
    -webkit-filter: grayscale(0);
    filter: none;
    filter: grayscale(0);
  }
}

h2 {
  font-size: 1.4rem;
  font-family: 'Shippori Mincho', serif;

  &+p {
    font-size: 3.2rem;
    font-weight: 400;
    margin-bottom: 40px;
    font-family: 'Shippori Mincho', serif;
  }
}

#price {
  padding: 40px 4.4% 180px;

  h2 {
    text-align: center;

    &+p {
      text-align: center;
    }
  }
}

.price-button {
  margin-top: 60px;
  text-align: center;

  & .button {
    margin: 0 auto;
  }
}

#TRAINERS {
  padding: 40px 4.4% 120px;
}

#access {
  padding: 40px 4.4% 120px 0;
}

iframe {
  width: 100%;
  aspect-ratio: 1/1; //アスペクト比（縦横比）を指定
}

.price-grid2 {
  margin: 80px auto 120px;
  width: 50%;

  &.camp {
    width: 100%;
    max-width: 1200px;
  }

  &-wrap {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 1450px) {
  .menu-list-bg {
    height: 550px;
  }
}

@media screen and (max-width: 1200px) {
  .qa {
    flex-direction: column;

    .top-items-title {
      width: 100%;
      text-align: left;
    }

    .qa-list {
      width: 100%;
    }
  }

  .menu-list-bg {
    height: 350px;

    &2 {
      top: 674px;
      height: 350px;
    }

    &3 {
      top: 1226px;
      height: 350px;
    }

    &4 {
      display: block;
      top: 1776px;
      height: 350px;
    }

    &5 {
      display: block;
      top: 2325px;
      height: 350px;
    }
  }

  .recommend-text {
    font-size: 4rem;
  }

  /* 立方体 */
  .cube {
    position: relative;
    margin: 30px auto;
    width: 200px;
    height: 200px;
    transform-style: preserve-3d;
    /* 子要素を3D空間 */
    animation: rotate 20s linear infinite;
    margin-left: 200px;

    &-wrap {
      margin-right: 70px;
    }

    & img {
      width: auto;
      height: 200px;
      transition: all 1s ease;
      opacity: 1;
    }
  }

  .top {
    transform: translate3d(0, -100px, 0) rotateX(90deg);
    background-color: #fff;
    opacity: 0.7;
  }

  .front {
    transform: translate3d(0, 0, -100px);
  }

  .right {
    transform: translate3d(-100px, 0, 0) rotateY(90deg);
  }

  .back {
    transform: translate3d(0px, 0px, 100px) rotateY(180deg);
  }

  .left {
    transform: translate3d(100px, 0, 0) rotateY(-90deg);
  }
}

@media screen and (max-width: 1000px) {
  .slider-text {
    &4 {
      font-size: 6rem;
    }
  }

  .camp-text2 {
    font-size: 3rem;
  }

  .price-item {
    width: 50%;
  }

  .price-grid2 {
    width: 50%;

    & .price-item {
      width: 100%;
    }
  }

  .access-cont {
    justify-content: center;
  }

  #access {
    padding: 40px 2% 120px 4.4%;
  }

  .access-wrap {
    text-align: right;
  }
}

@media screen and (max-width: 900px) {
  .access {
    flex-direction: column;

    .top-items-title {
      width: 100%;
      text-align: left;
    }

    .access-list {
      width: 100%;
    }
  }

  .price-cam-item-wrap {
    flex-direction: column;
  }

  .price-cam-item {
    margin: 0px auto 40px;
    width: 100%;

    &:nth-child(1) {
      margin-right: auto;
    }

    &:nth-child(3) {
      margin: auto;
    }
  }

  .price-list-des {
    flex-direction: column;
  }

  .price-list-des-grid {
    width: 100%;

    &:last-of-type {
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  .price-list-wrap {
    & .price-bg {
      opacity: 0.1;
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      z-index: -1;
      width: 100%;
      max-width: 1000px;

      &2 {
        display: block;
        font-family: 'mafw';
        font-size: 6rem;
        opacity: 0.1;
        position: absolute;
        right: 0px;
        top: 100px;
        z-index: -1;
      }

    }
  }



  .info-list-item {
    flex-direction: column;
  }

  .info-list-title {
    width: 100%;
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  .info-bg {
    bottom: 0;
  }

  .info-list-des {
    font-size: 1.4rem;
  }

  .waku {
    width: 100%;

    & div {
      justify-content: flex-start;
    }
  }

  .price-item {
    width: 100%;
  }

  .pc-none {
    display: block;

    &-inline {
      display: inline;
    }
  }

  .sp-none {
    display: none;
  }

  .price-item-title.camp {
    font-size: 3rem;
  }

  .price-list-item {
    flex-direction: column;
    // box-shadow: -1px 19px 31px -17px #777777;
  }

  .price-list-title {
    width: 100%;
    margin-bottom: 15px;
    font-size: 1.8rem;
    // background-color: $sub;
    // color: #fff;
    // padding: 15px;
    // font-weight: bold;
    // position: relative;
    // margin-bottom: 40px;

    // &::after {
    //       width: 0;
    // height: 0;
    // position: absolute;
    // top: 100%;
    // left: 50%;
    // margin: 0 0 0 -25px;
    // border: 25px solid transparent;
    // border-top-color: #ada554;
    // content: '';
    // }
  }

  .price-list-des-grid {
    flex-direction: column;
    font-size: 1.6rem;

    &2 {
      font-size: 1.6rem;
    }
  }
}




@media screen and (max-width: 360px) {
  .price-item-title.camp {
    font-size: 2.5rem;
  }

}

@media screen and (max-width: 850px) {

  .member-wrap li {
    max-width: 100%;

    &:nth-child(2) {
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 0px;
    }

  }


}


@media screen and (max-width: 767px) {

  .lesson-schedulebox ul li.hours {
    width: 20%;
  }

  .lesson-schedule-note {
    display: block;
    font-size: 1.6rem;
    margin-bottom: 10px;
  }

  .lesson-schedulebox ul li dl dt {
    border-right: none;
  }

  .lesson-schedulebox ul li.hours dl dt {
    border-right: 1px solid #fff;
  }



}

@media screen and (max-width: 768px) {

  .facilittes {
    .item-grid {
      flex-direction: column;
      padding: 0 4.4%;
    }

    .item-grid-text {
      margin: 0;
      width: 100%;
      margin-bottom: 20px;
    }

    .item-grid-des {
      margin-bottom: 40px;
    }
  }

  .news {
    flex-direction: column;

    .top-items-title {
      width: 100%;
      text-align: left;
    }

    .news-list {
      width: 100%;
    }
  }

  .menu-list-bg {
    display: none;
  }

  .menu-list-img {
    display: block;
    margin-bottom: 40px;
  }

  .price {

    .checkbox-list-text {
      text-align: center !important;
    }

    .checkbox-list {
      flex-direction: column;
      align-items: center;
    }

    .checkbox__item {
      margin-bottom: 10px;
    }

    .price-grid2 {
      width: 100%;
    }
  }

  .top-video-wrap.active.video-box .video-boxInner {
    height: 100vh;
  }

  .top-video-wrap {
    top: 37vw;
  }

  .title-wrap h2 {
    font-size: 1.7rem;
  }

  .title-wrap h1 {
    font-size: 3rem;
  }

  .top-inner-img {
    width: 70%;
  }

  .head-subtitle {
    font-size: 2rem;
  }

  .camp-text2 {
    font-size: 2rem;

    &.price {
      font-size: 3rem;
    }
  }

  .head-subtitle-wrap .price-item-des-wrap .price-item-des-title {
    font-size: 1.5rem;
  }

  .price-item-des-numtext {
    font-size: 3rem;
  }

  .head-subtitle-wrap .price-item-des-wrap .arrow-bottom {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 20px;
    border-bottom: 4px solid #fff;
    border-right: 4px solid #fff;
    transform: translateX(-100%) rotate(-45deg);
    opacity: 0;
    transition: all 1s;
  }

  .price-item-des-numtext2 {
    font-size: 3rem;
  }

  .button-wrap {
    height: 70px;
  }

  .head-title {
    font-size: 5rem;
  }

  .button {
    font-size: 1.5rem;
    max-width: 300px;
  }

  .sp-none {
    display: none;
  }

  .pc-none {
    display: block;
  }

  .slider-text {
    font-size: 6rem;
    letter-spacing: 1.8px;

    &4 {
      font-size: 3rem;
    }
  }
}

.attention {
  position: relative;
  display: inline-block;
  padding: 0 30px;
  margin-bottom: 10px;
  color: #ff4081;

  animation: fluffy1 3s ease infinite;

  p {
    font-size: 1.5rem;
    font-weight: 600;
    color: #ff4081;
  }
}

@keyframes fluffy1 {
  0% {
    transform: translateY(0);
  }

  5% {
    transform: translateY(0);
  }

  10% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-15px);
  }

  25% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-15px);
  }

  50% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(0);
  }
}

.attention:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  width: 1px;
  height: 100%;
  background: #ff4081;
  border-radius: 3px;
  transform: rotate(-25deg);
}

.attention:after {
  position: absolute;
  content: '';
  right: 0;
  top: 0;
  width: 1px;
  height: 100%;
  background: #ff4081;
  border-radius: 3px;
  transform: rotate(25deg);
}




.price-item-des {

  &-numtext2 {
    font-size: 50px;
    margin-right: -3px;
    position: relative;
    color: $sub;

    &::after {
      position: absolute;
      bottom: calc(0% - 2px);
      left: 0;
      content: '';
      width: 100%;
      height: 5px;
      background: #ff4081;
      transform: scale(0, 1);
      transform-origin: left top;
      transition: transform 0.5s;
    }

    &.active::after {
      transform: scale(1, 1);
    }

    &-wrap {
      position: relative;

      opacity: 0;
      -webkit-transition: all 4s;
      -moz-transition: all 4s;
      -ms-transition: all 4s;
      -o-transition: all 4s;
      transition: all 4s;

      &.active {
        opacity: 1;
      }
    }

    &-tag {
      position: absolute;
      width: 100px;
      background: $sub;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      left: -105px;
      font-size: 1.2rem;
      transform: rotate(-5deg);
    }
  }


  &-numtext {
    font-size: 35px;
    margin-right: -3px;
    position: relative;
    display: inline-block;
    margin: 0 10px;

    &.none {
      text-align: center;

      &::after {
        background: inherit;
      }
    }

    &::after {
      position: absolute;
      bottom: calc(50% - 5px);
      left: 0;
      content: '';
      width: 100%;
      height: 5px;
      background: #ff4081;
      transform: scale(0, 1);
      transform-origin: left top;
      transition: transform 0.5s;
    }

    &.active::after {
      transform: scale(1, 1);
    }
  }
}

.box4 {
  padding: 20px 0;
  display: block;
  border-top: 2px dotted #ff4081;
  margin: 40px 0 20px;

  .con1 {
    font-size: 1.8rem;
    margin: 10px 0;

    .sm {
      font-size: 60%;
    }
  }

}

.box4 p {
  font-size: 1.6rem;
  margin: 0;
  padding: 0;
}

.lh1 {
  line-height: 1.1;
  margin-top: 5px;
}

.flow {
  margin-top: 240px;

  .top-items-title {
    text-align: center;
    margin: 0 auto;
  }

  .box26 {
    position: relative;
    margin: 20px auto;
    padding: 30px 20px;
    border: solid 2px #ada554;
    border-radius: 8px;
    max-width: 600px;


    img {
      margin-top: 10px;
    }
  }

  .box26 .box-title {
    position: absolute;
    display: inline-block;
    top: -13px;
    left: 10px;
    padding: 0 9px;
    line-height: 1;
    font-size: 20px;
    background: #FFF;
    color: #ada554;
    font-weight: bold;
    font-family: 'Shippori Mincho', serif;

    &-sub {
      font-family: 'Shippori Mincho', serif;
      font-size: 2rem;
      color: #ada554;
      font-weight: bold;
    }
  }

  .box26 p {
    font-size: 1.4rem;
    margin: 0;
    padding: 0;
  }

  .arrow-bottom2 {
    display: flex;
    width: 18px;
    height: 18px;
    margin: 40px auto;
    border-bottom: 2px solid #58574c;
    border-right: 2px solid #58574c;
    transform: translateY(-100%) rotate(45deg);
    opacity: 0;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;


    &.active {
      transform: translateY(0) rotate(45deg);
      opacity: 1;
    }

  }
}


.news-button {

  &-wrap {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    width: 100%;
    margin-top: 40px;
  }

  font-size: 1.2rem;
  width: 70px;
  border: 1px solid #c2c3cc;
  border-radius: 25px;
  padding: 10px;
  display: flex;
  justify-content: center;
  letter-spacing: 1.5px;
  margin: 0 5px 10px;
  cursor: pointer;

  &.none {
    opacity: .4;
    pointer-events: none;
  }
}

a {
  text-decoration: none;
}

.annotation {
  width: 100%;
  color: red;
  font-size: 1.4rem;
  font-weight: bold;

  &-wrap {
    max-width: 1200px;
    margin: 10px auto;
    padding: 0 1%;
  }
}
</style>
